class CraftSpiritCheckout {
  #section = null;
  #formData = null;
  
  constructor(section, formData) {
    this.#section = section;
    this.#formData = formData;
  }

  async addToCart() {
    if (this.#section.cart) {
      this.#formData.append(
        'sections',
        this.#section.cart.getSectionsToRender().map((section) => section.id)
      );
      this.#formData.append('sections_url', window.location.pathname);
      this.#section.cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    delete config.headers['Content-Type'];
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = this.#formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then( async (response) => {
        if (response.status) {
          this.#handleError(response);
          return;
        } else if (!this.#section.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        await this.#refreshCart();
        this.#updateCart(response);
      }).catch((e) => {
        console.error(e);
      });
  }

  #handleError(response) {
    publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: this.#formData.get('id'),
      errors: response.errors || response.description,
      message: response.message,
    });
    this.#section.handleErrorMessage(response.description);

    const soldOutMessage = this.#section.submitButton.querySelector('.sold-out-message');
    if (!soldOutMessage) return;
    this.#section.submitButton.setAttribute('aria-disabled', true);
    this.#section.submitButtonText.classList.add('hidden');
    soldOutMessage.classList.remove('hidden');
    this.#section.error = true;
  }

  #updateCart(response) {
    CartPerformance.measure("add:paint-updated-sections", () => {
      this.#section.cart.renderContents(response);
    });
    
    this.#section.cart.querySelector('.drawer__inner-empty') &&
      this.#section.cart.querySelector('.drawer__inner-empty').classList.remove('drawer__inner-empty');
  }

  async #refreshCart() {
    const cart = await this.#section.refreshCart();
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'my-craft-gin-add-to-cart',
      productVariantId: this.#formData.id,
      cartData: cart,
    });

    if (this.#section.cart && this.#section.cart.classList.contains('is-empty')) {
      this.#section.cart.classList.remove('is-empty');
    }
  }
}
